import {articleAll, articleCategory} from "../../../api/server/article"
import Nomsg from "../../../components/Nomsg"
import commonMixin from "../../../mixin/common"
export default {
  name: 'MessagePage',
  mixins: [commonMixin],
  data () {
    return {
      id: null,
      list: null,
      category: null
    }
  },
  components: {
    nomsg: Nomsg
  },
  computed: {
  },
  methods: {
    onDetail (id) {
      this.$router.push({name: 'news-detail', query: {id: id}})
    },
    _getList () {
      let id = this.id
      if (!this.id) {
        id = ''
      }
      let query = {
        id: id
      }
      articleAll(query).then((res) => {
          if (res.code === 200 && res.data) {
            this.list = res.data
          }
        }
      )
    },
    _getCategory () {
      articleCategory({id: this.id}).then( (res) => {
        if (res.code === 200) {
          this.category = res.data
        }
      })
    },
    reset () {
      this._getCategory()
      this._getList(null)
    },
    handleRoute (route) {
      if (route.name === 'news') {
        this.id = route.query.id
        this.reset()
      }
    }
  },
  watch: {
    'route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}